
import React,{useEffect} from "react";
import Pricing from "../Components/Pricing";

const PricingPage = () => {
    useEffect(() => {
      window.scrollTo(0, 0); // Scroll to the top on mount
    }, []);
  return (
    <>
      <Pricing />
    </>
  );
};

export default PricingPage;
